import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { DownloadIcon } from '@heroicons/vue/solid';
import { VaultService } from '@/services';
import AnalyticsService from '@/services/analytics/AnalyticsService';


export default /*@__PURE__*/_defineComponent({
  __name: 'CallAudioDownloadButton',
  props: {
    callId: {
        type: Number,
        required: true,
    },
},
  setup(__props) {



async function downloadCallAudio(callId: number): Promise<void> {
    try {
        if (!callId) return;

        AnalyticsService.trackingAction('CallAudioDownload');

        // Fetch audio data from VaultService
        const { data } = await VaultService.getCallAudio(callId);

        // Create blob and object URL
        const blob = new Blob([data], { type: 'audio/mpeg' });
        const url = URL.createObjectURL(blob);

        // Create download link
        const link = document.createElement('a');
        link.href = url;
        link.download = `${callId}.mp3`;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
    } catch (error) {
        console.error('Error downloading call audio:', error);
    }
}

return (_ctx: any,_cache: any) => {
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
    variant: "primary",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadCallAudio(__props.callId)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DownloadIcon), {
        class: "h-7 w-7",
        "aria-hidden": "true"
      }),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('core.actions.Download')), 1)
    ]),
    _: 1
  })), [
    [_directive_tippy, _ctx.$t('core.actions.Download')]
  ])
}
}

})